import config from '../../config'

import { IGetPutRequest } from '../../interfaces'

const getUpdateItbsTemplatesMutationRequest: IGetPutRequest = params => {
  const { airportId } = params

  return {
    method: 'put',
    url: `${config.baseUrl}/${airportId}/InspectionTypeBuilders/Templates`,
  }
}

export default getUpdateItbsTemplatesMutationRequest
